import {Component, ElementRef, HostBinding, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import { ColorpickerPanelComponent } from '../../../editor-tools/core/ui/color-picker/colorpicker-panel.component';
import { OverlayPanel, PanelConfig } from '../../../editor-tools/core/ui/overlay-panel/overlay-panel.service';
import { Settings } from '../../../editor-tools/core/config/settings.service';

@Component({
    selector: 'color-widget',
    templateUrl: './color-widget.component.html',
    styleUrls: ['./color-widget.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: ColorWidgetComponent,
        multi: true,
    }]
})
export class ColorWidgetComponent implements ControlValueAccessor {
    @ViewChild('colorPickerButton', {read: ElementRef}) colorPickerButton: ElementRef;

    @Input() @HostBinding('class.compact') compact: boolean = false;

    /**
     * Currently selected color;
     */
    public selectedColor: string = '#000';

    /**
     * Preset colors to display in the widget.
     */
    public colors: string[];

    public propagateChange: Function;

    /**
     * ColorWidgetComponent Constructor.
     */
    constructor(
        private overlayPanel: OverlayPanel,
        private config: Settings,
    ) {
        this.colors =  [
            '#000',
            '#fff',
            'rgb(242, 38, 19)',
            'rgb(249, 105, 14)',
            'rgb(253, 227, 167)',
            'rgb(4, 147, 114)',
            'rgb(30, 139, 195)',
            'rgb(142, 68, 173)',
        ];
    }

    public changeColor(color: string) {
        this.selectedColor = color;
        this.propagateChange(color);
    }

    /**
     * Open color picker and update color once selected.
     */
    public openColorPicker() {
        const config = {position: 'bottom', hasBackdrop: true, origin: this.colorPickerButton} as PanelConfig;

        this.overlayPanel.open(ColorpickerPanelComponent, config)
            .valueChanged().subscribe(color => this.changeColor(color));
    }

    public writeValue(value: string|null) {
        this.selectedColor = value;
    }

    public registerOnChange(fn: Function) {
        this.propagateChange = fn;
    }

    public registerOnTouched() {}
}
